var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.time)?_vm._l((_vm.convertedTime),function(time,key){return _c('span',{key:key},[(time)?[_vm._v(" "+_vm._s(time)+_vm._s(_vm.$t(("webmaster.offer.aside.shortUnitsTime." + key)))+" ")]:_vm._e()],2)}):[_vm._v(" 0 ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }